import { render, staticRenderFns } from "./MicroApplicationRoute.vue?vue&type=template&id=9cc5d93a&scoped=true"
import script from "./MicroApplicationRoute.vue?vue&type=script&lang=ts"
export * from "./MicroApplicationRoute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc5d93a",
  null
  
)

export default component.exports